/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 14:55:14
 * @LastEditors: linxi
 * @LastEditTime: 2021-05-25 18:58:38
 */
import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import appReducer from "./appSlice";
import doctorReducer from '../features/DoctorStation/DoctorSlice'
import accountReducer from '../features/AccountStation/AccountSlice'
import OrganizationReducer from '../features/OrganizationMessage/OrganizationMessageSlice'
import exceptionReducer from '../features/ExceptionMessage/ExceptionMessageSlice'
import processingReducer from '../features/ProcessingData/ProcessingDataSlice'
import factoryReducer from '../features/Factory/FactorySlice'
import medicalReducer from '../features/ProvinceDataAnalyse/MedicalData/MedicalDataSlice'
import warningRulesReducer from '../features/warningRule/warningRuleSlice'
import prisonReducer from '../features/HealthPrisonAnaylse/PrisonData/PrisonDataSlice'
import fileListReducer from '../features/FileData/fileDataSlice'

export const store = configureStore({
  reducer: {
    app: appReducer,
    doctorStation: doctorReducer,
    accountStation: accountReducer,
    Organization:OrganizationReducer,
    exception:exceptionReducer,
    processing:processingReducer,
    factory:factoryReducer,
    medical:medicalReducer,
    warningRule:warningRulesReducer,
    prison:prisonReducer,
    fileList:fileListReducer
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
export type AppThunkApi<RejectValue = void> = {
  state: RootState;
  dispatch: AppDispatch;
  rejectValue: RejectValue;
};
